export default __webpack_public_path__ + "728a835dc9004f77c6a907c3cf8d067b.svg";